import { redirectToDashboardRoute } from '@/router/router';
import { isDarkBackground, isPostProductStep } from '@/utils/showLayoutElements';
import { Button, ButtonProps, Text, useMantineTheme } from '@mantine/core';
import { Link, useParams } from '@tanstack/router';
import { ArrowUpward } from './icons/ArrowUpward';
import { Close } from './icons/Close';

export const RedirectToDashboardButton = ({ children, ...rest }: ButtonProps) => {
  const { stepId } = useParams();

  const theme = useMantineTheme();

  if (!stepId) return null;

  const color = isDarkBackground(stepId) ? theme.colors.minor[1] : theme.colors.primary[0];

  const RedirectButtonContent = () => (
    <>
      <Text
        mr={4}
        fw={700}
        c={color}
      >
        {children ?? `Continue later`}
      </Text>
      {isPostProductStep(stepId) ? (
        <ArrowUpward color={theme.colors.tertiary[1]} />
      ) : (
        <Close color={theme.colors.tertiary[1]} />
      )}
    </>
  );

  return (
    <Link
      to={redirectToDashboardRoute.id}
      preload={false}
      style={{
        alignSelf: 'center',
      }}
    >
      <Button
        type="button"
        sx={{
          root: {
            backgroundColor: 'transparent',
            border: 'none',
          },
        }}
        p={0}
        {...rest}
      >
        <RedirectButtonContent />
      </Button>
    </Link>
  );
};
